"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactIs = require("react-is");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Input = _interopRequireDefault(require("../Input"));

var _excluded = ["label", "className"];

var LabledInput = function LabledInput(_ref) {
  var label = _ref.label,
      className = _ref.className,
      inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledLabledInput, {
    className: className
  }, typeof label === 'string' || (0, _reactIs.isFragment)(label) ? /*#__PURE__*/_react["default"].createElement(StyledLabel, null, label) : label, /*#__PURE__*/_react["default"].createElement(StyledInput, inputProps));
};

LabledInput.propTypes = {
  className: _propTypes["default"].string,
  label: _propTypes["default"].node.isRequired
};
LabledInput.defaultProps = {
  className: ''
};

var StyledLabledInput = _styledComponents["default"].div.withConfig({
  displayName: "LabledInput__StyledLabledInput",
  componentId: "sc-1xgccco-0"
})([""]);

var StyledInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "LabledInput__StyledInput",
  componentId: "sc-1xgccco-1"
})(["width:100%;font-size:inherit;box-sizing:border-box;"]);

var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "LabledInput__StyledLabel",
  componentId: "sc-1xgccco-2"
})(["display:flex;margin-bottom:6px;font-size:9px;line-height:11px;font-weight:normal;text-transform:uppercase;color:", ";"], function (props) {
  return props.theme.colors.blackLight;
});

LabledInput.Label = StyledLabel;
var _default = LabledInput;
exports["default"] = _default;